import {
    Box,
    IconButton,
    LinearProgress,
    Modal,
    ToggleButton,
    ToggleButtonGroup,
    Typography,
} from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Grid from "@mui/material/Grid2";
import { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from "src/stateManagement/redux";
import {
    IUpdateDiagnosticForActivity,
    updateFieldVariablesValues,
    UpdateDiagnosticForActivity,
} from 'src/shared/util/updateDataServer';
import Swal from 'sweetalert2';
import { loadLocationDetails } from 'src/stateManagement/redux/slices/location/asyncReducers';
import { selectMainState } from "src/stateManagement/redux";
import { DiagnosticoSplitView } from './DiagnosticoSplitView';
import { ModalVariables } from '../cartas_dinagraficas/components/modalVariables';
import { OptimizationActivities } from '../cartas_dinagraficas/components/bm_diagnostic/modalDiagnosticOptimization';
import { Requerimientos } from '../requerimientos/requerimientos';
import SubSurfaceJobs from '../tendencias/components/subSurfaceJob';
import WaterTest from '../tendencias/components/waterTest';
import { SteamModule } from '../steam';
import { ProductionModule } from '../production';
import { FileAttachment } from '../files/fileattachment';
import { DynSort } from '../cartas_dinagraficas/components/sort_dyn';
import { QuickAddOptimizationModal } from '../cartas_dinagraficas/components/bm_diagnostic/quick_add_optimization/QuickAddOptimizationModal';
import { QuickAddRequirementModal } from '../cartas_dinagraficas/components/bm_diagnostic/quick_add_optimization/QuickAddRequirementModal';
import { normalizeText } from 'src/shared/util/normalizeText';
import '../cartas_dinagraficas/components/styles.scss';
import './diagnosticoV2.scss';
import { useRef } from 'react';
import type { SecondaryTab } from './DiagnosticoLeftPanel';

export type DiagnosticoV2Mode = 'liquidLevel' | 'dynCard' | 'generic';

export interface DiagnosticoV2Props {
    open: boolean;
    onClose: () => void;
    mode: DiagnosticoV2Mode;
    sourceData?: any;
}

type MainTab =
    | 'variables'
    | 'diagnostic'
    | 'optimizationOptions'
    | 'requirements'
    | 'trabajosSubsuelo'
    | 'muestrasAyS'
    | 'steamInjection'
    | 'productionTest'
    | 'filesManager';

const condicion_fondo_list = [
    { id: "Golpe de Fluido", name: "Golpe de Fluido", dissabled: true },
    { id: "Inteferencia por Gas", name: "Inteferencia por Gas", dissabled: true },
    { id: "Pendiente por Determinar", name: "Pendiente por Determinar" },
    { id: "Buenas Condiciones", name: "Buenas Condiciones" },
    { id: "Golpe de Bomba", name: "Golpe de Bomba", dissabled: true },
    { id: "Baja Accion de Bombeo", name: "Baja Accion de Bombeo" },
    { id: "Fuga en Valvula Viajera", name: "Fuga en Valvula Viajera", dissabled: true },
    { id: "Fuga en Valvula Fija", name: "Fuga en Valvula Fija", dissabled: true },
    { id: "Cierre Tardio de Valvula Fija", name: "Cierre Tardio de Valvula Fija", dissabled: true },
    { id: "Cierra Tardio de Valvula Viajera", name: "Cierra Tardio de Valvula Viajera", dissabled: true },
    { id: "Flumping", name: "Flumping", dissabled: true },
];

export const DiagnosticoV2Modal = ({ open, onClose, mode, sourceData }: DiagnosticoV2Props) => {
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState<MainTab>('diagnostic');
    const [secondaryTab, setSecondaryTab] = useState<SecondaryTab>(mode === 'liquidLevel' ? 'actualizarNivel' : 'ipr');
    const tabsScrollRef = useRef<HTMLDivElement>(null);
    const [variablesToUpdate, setVariablesToUpdate] = useState<any>(undefined);
    const [activeDiagnostic, setActiveDiagnostic] = useState<IUpdateDiagnosticForActivity>();
    const [condicionFondoList, setCondicionFondoList] = useState<any[]>(condicion_fondo_list);
    const [subSurfaceDataTable, setSubSurfaceDataTable] = useState<any[]>([]);

    const { id } = useParams();
    const dispatch = useDispatch();
    const { projectId, locationId, productionTests, waterTests, fieldActivities, optimizationRequirements, requirements } = useSelector((state) => state.location);
    const { activeUser } = useSelector((state) => state.main);
    const { configModules } = useSelector(selectMainState);

    const liquidLevel = mode === 'liquidLevel' ? sourceData : undefined;
    const originFieldActivityId = liquidLevel?.fieldActivityId || sourceData?.fieldActivityId;

    const [showQuickAddRequirement, setShowQuickAddRequirement] = useState(false);
    const [showQuickAddOptimization, setShowQuickAddOptimization] = useState(false);
    const [pendingActivityData, setPendingActivityData] = useState<{ types: string[]; simulationDate?: string; isWellWithMultiplesTDSEntries: boolean; existingActivities?: any[] } | null>(null);
    const [lastProductionTest, setLastProductionTest] = useState<any>(undefined);
    const [lastWaterTest, setLastWaterTest] = useState<any>(undefined);
    const [averageWaterTestsLast5, setAverageWaterTestsLast5] = useState<{
        average: number;
        standardDeviation: number;
        startDate: string;
        endDate: string;
    } | undefined>(undefined);

    useEffect(() => {
        if (productionTests?.length > 0) {
            const sorted = [...productionTests].sort((a, b) => new Date(b.testDate).getTime() - new Date(a.testDate).getTime());
            setLastProductionTest(sorted[0]);
        }
    }, [productionTests]);

    useEffect(() => {
        if (waterTests?.length > 0) {
            const sorted = [...waterTests].sort((a, b) => new Date(b.samplingDate).getTime() - new Date(a.samplingDate).getTime());
            setLastWaterTest(sorted[0]);
            if (sorted.length > 1) {
                const prev5 = sorted.slice(1, 6);
                const values = prev5.map((t) => parseFloat(t.totalWaterPercentage)).filter((v) => !isNaN(v));
                if (values.length > 0) {
                    const avg = values.reduce((s, v) => s + v, 0) / values.length;
                    const dates = prev5.map((t) => new Date(t.samplingDate)).sort((a, b) => a.getTime() - b.getTime());
                    setAverageWaterTestsLast5({
                        average: avg,
                        standardDeviation: 0,
                        startDate: dates[0]?.toISOString() || '',
                        endDate: dates[dates.length - 1]?.toISOString() || '',
                    });
                }
            }
        }
    }, [waterTests]);

    useEffect(() => {
        if (Array.isArray(configModules?.bottomHoleConditions)) {
            const filtered = [...configModules.bottomHoleConditions].filter(
                (c) => c?.enabledOn?.includes(activeDiagnostic?.candidateSate || '') || c.name === activeDiagnostic?.bottomHoleCondition
            );
            setCondicionFondoList(filtered.length > 0 ? filtered : condicion_fondo_list);
        }
    }, [configModules, activeDiagnostic?.candidateSate]);

    useEffect(() => {
        if (open) {
            setSecondaryTab(mode === 'liquidLevel' ? 'actualizarNivel' : 'ipr');
        }
    }, [open, mode]);

    useEffect(() => {
        if (!liquidLevel && !sourceData) return;

        const originFieldActivityIds = [liquidLevel?.fieldActivityId || sourceData?.fieldActivityId].filter(Boolean);
        if (originFieldActivityIds.length === 0) return;

        const base: any = { originFieldActivityIds };
        if (liquidLevel) {
            base.liquidLevel = liquidLevel.liquidLevel ?? 0;
            base.pip = liquidLevel.pip ?? 0;
            base.pwf = liquidLevel.pwf ?? 0;
            base.pumpSumergence = liquidLevel.pumpSumergence ?? 0;
        }
        setVariablesToUpdate(base);

        const prev = liquidLevel?.['diagnosticVariables'] || sourceData?.['diagnosticVariables'] || [];
        const getVal = (id: string) => prev?.find((v: any) => v.id === id)?.value || '';

        const newDiagnostic: IUpdateDiagnosticForActivity = {
            originFieldActivityIds,
            projectId: projectId || '',
            locationId: locationId || '',
            diagnostic: getVal('26fd1c80-ec8d-11ef-95e3-00505652cca1') || '',
            recommendation: getVal('26fd1ece-ec8d-11ef-95e3-00505652cca1') || '',
            candidateSate: getVal('26fd1f13-ec8d-11ef-95e3-00505652cca1') || '',
            bottomHoleCondition: getVal('26fd1f4d-ec8d-11ef-95e3-00505652cca1') || '',
            subBottomHoleCondition: getVal('3e545921-fc61-11ef-a39b-00505652cca1') || '',
            bottomHoleFillage: parseFloat(getVal('26fd1f8a-ec8d-11ef-95e3-00505652cca1')) || 0,
            requiredUserId: activeUser?.id || '',
            executedAt: new Date(),
            ept: parseFloat(getVal('bca80cfd-fcdd-11ef-a39b-00505652cca1')) || 0,
            theoricalProduction: parseFloat(getVal('3e545b5c-fc61-11ef-a39b-00505652cca1')) || 0,
            pumpEfficiency: parseFloat(getVal('81047dd8-05d4-11f0-af91-00505652cca1')),
            adjustProduction: parseFloat(getVal('1a6387e8-05db-11f0-af91-00505652cca1')) || 0,
            mpt: 0,
            dplunger: parseFloat(getVal('e47fc3c4-fc6f-11ef-a39b-00505652cca1')) || 0,
            newFieldActivityState: 'finished',
            optimizationActivitiesSelected: [],
            includeAttachments: false,
            attachedFiles: [],
            runLife: 0,
            lastSubSurfaceJobFinishedDate: '',
            daysAfterSteamInjection: 0,
            lastLocationEventHistoryChangeDate: '',
            cicleCount: 0,
        };
        setActiveDiagnostic(newDiagnostic);
    }, [liquidLevel, sourceData, open]);

    const generateSimpleDiagnostic = () => {
        if (!activeDiagnostic) return;
        const bc = activeDiagnostic.bottomHoleCondition;
        const fill = activeDiagnostic.bottomHoleFillage ?? 0;
        const ept = activeDiagnostic.ept;
        const mpt = activeDiagnostic.mpt;
        const liquidLevelVal = liquidLevel?.liquidLevel ?? variablesToUpdate?.liquidLevel;
        let diagnostic = '';
        if (liquidLevelVal != null) diagnostic += `Nivel de líquido: ${liquidLevelVal} ft. `;
        if (bc) {
            diagnostic += `Condición de fondo: ${bc}. `;
            if (['Golpe de Fluido', 'Inteferencia por Gas', 'Buenas Condiciones'].includes(bc)) {
                const fillText = typeof fill === 'number' ? fill.toFixed(1) : fill;
                if (fill < 20) diagnostic += `Llenado crítico de bomba (${fillText}%). `;
                else if (fill < 50) diagnostic += `Llenado medio-bajo (${fillText}%). `;
                else if (fill < 80) diagnostic += `Llenado medio-aceptable (${fillText}%). `;
                else diagnostic += `Buen llenado (${fillText}%). `;
            }
        }
        if (typeof ept === 'number' && typeof mpt === 'number') diagnostic += `EPT ${ept.toFixed(2)} vs MPT ${mpt.toFixed(2)}.`;
        handleOnChangeValue(diagnostic.trim() || 'Diagnóstico generado.', 'diagnostic');
    };

    const handleOnChangeValue = (value: any, label: string) => {
        const next = { ...activeDiagnostic } as any;
        next[label] = value;
        if (label === 'bottomHoleCondition') {
            const def = ['Fuga en Valvula Viajera', 'Fuga en Valvula Fija', 'Cierre Tardio de Valvula Fija', 'Cierra Tardio de Valvula Viajera', 'Flumping', 'Baja Accion de Bombeo'];
            if (value === 'Golpe de Fluido') {
                const fill = activeDiagnostic?.bottomHoleFillage || 0;
                next.subBottomHoleCondition = fill < 20 ? 'Golpe de Fluido Critico (<20%)' : fill < 50 ? 'Golpe de Fluido Llenado Medio (20% al 50%)' : 'Golpe de Fluido Buen Llenado (50% al 90%)';
            } else if (value === 'Inteferencia por Gas') {
                const fill = activeDiagnostic?.bottomHoleFillage || 0;
                next.subBottomHoleCondition = fill < 20 ? 'Inteferencia por Gas Critico (<20%)' : fill < 50 ? 'Inteferencia por Gas Llenado Medio (20% al 50%)' : 'Inteferencia por Gas Buen Llenado (50% al 90%)';
            } else {
                next.subBottomHoleCondition = def.includes(value) ? 'Deficiente' : value;
            }
        }
        setActiveDiagnostic(next);
    };

    const addRemoveOptimizationActivity = (activity: any, add: boolean) => {
        if (!activeDiagnostic) return;
        const id = activity?.activity ? `${activity.optimizationActivityId}-${activity.activity}` : activity?.id;
        const optimizationActivities = activeDiagnostic.optimizationActivitiesSelected || [];
        const filteredActivities = optimizationActivities.filter((opt) => opt.id !== id);
        const newOptimizationActivitiesSelected = [...filteredActivities];
        if (add) {
            newOptimizationActivitiesSelected.push({
                id,
                name: activity.activity,
                simulated: activity?.simulated || false,
                optimizationActivityId: activity.optimizationActivityId,
                main: activity?.main || false,
                isWellWithMultiplesTDSEntries: activity?.isWellWithMultiplesTDSEntries || false,
            });
        }
        setActiveDiagnostic({ ...activeDiagnostic, optimizationActivitiesSelected: newOptimizationActivitiesSelected });
    };

    const handleConvertToMain = (activity: any) => {
        if (!activeDiagnostic) return;
        const id = activity?.activity ? `${activity.optimizationActivityId}-${activity.activity}` : activity?.id;
        const optimizationActivities = activeDiagnostic.optimizationActivitiesSelected || [];
        const newOptimizationActivitiesSelected = optimizationActivities.map((opt) =>
            opt.id === id ? { ...opt, main: true } : { ...opt, main: false }
        );
        newOptimizationActivitiesSelected.sort((a, b) => (b.main ? 1 : 0) - (a.main ? 1 : 0));
        setActiveDiagnostic({ ...activeDiagnostic, optimizationActivitiesSelected: newOptimizationActivitiesSelected });
    };

    useEffect(() => {
        if (!pendingActivityData || !activeDiagnostic) return;
        if (pendingActivityData.existingActivities && pendingActivityData.existingActivities.length > 0) {
            pendingActivityData.existingActivities.forEach((existingActivity) => {
                addRemoveOptimizationActivity(existingActivity, true);
            });
            setPendingActivityData(null);
            return;
        }
        const originFieldActivityIdVal = activeDiagnostic?.originFieldActivityIds?.[0];
        if (!originFieldActivityIdVal || !pendingActivityData.types || pendingActivityData.types.length === 0) {
            setPendingActivityData(null);
            return;
        }
        const allRequirements = [...(optimizationRequirements || []), ...(requirements || [])];
        const createdRequirement = allRequirements
            .filter(
                (req: any) =>
                    req.originFieldActivityId === originFieldActivityIdVal &&
                    pendingActivityData.types.some((type: string) => normalizeText(req.activity) === normalizeText(type))
            )
            .sort((a: any, b: any) => new Date(b.requiredDate).getTime() - new Date(a.requiredDate).getTime())[0];
        if (createdRequirement) {
            const activityToSelect = {
                optimizationActivityId: createdRequirement.optimizationActivityId,
                activity: pendingActivityData.types[0],
                simulated: !!pendingActivityData.simulationDate,
                isWellWithMultiplesTDSEntries: pendingActivityData.isWellWithMultiplesTDSEntries,
            };
            addRemoveOptimizationActivity(activityToSelect, true);
            setPendingActivityData(null);
        }
    }, [optimizationRequirements, requirements, pendingActivityData, activeDiagnostic]);

    const handleActivityCreated = (activityData: { types: string[]; simulationDate?: string; isWellWithMultiplesTDSEntries: boolean; existingActivities?: any[] }) => {
        if (activityData.existingActivities && activityData.existingActivities.length > 0) {
            activityData.existingActivities.forEach((existingActivity) => addRemoveOptimizationActivity(existingActivity, true));
        }
        if (!activityData.types || activityData.types.length === 0) return;
        setPendingActivityData(activityData);
    };

    const handleRequirementCreated = (requirementData: { types: string[]; existingRequirements?: any[] }) => {
        if (requirementData.existingRequirements && requirementData.existingRequirements.length > 0) {
            requirementData.existingRequirements.forEach((existingRequirement) => addRemoveOptimizationActivity(existingRequirement, true));
        }
        if (!requirementData.types || requirementData.types.length === 0) return;
        setPendingActivityData({ types: requirementData.types, simulationDate: undefined, isWellWithMultiplesTDSEntries: false });
    };

    const onChangeLiquidLevel = (value: number, label: string) => {
        setVariablesToUpdate((prev: any) => ({ ...prev, [label]: value }));
    };

    const validateDiagnostic = () => {
        const fields = [
            { field: 'diagnostic', msg: 'El campo diagnóstico es requerido' },
            { field: 'recommendation', msg: 'El campo recomendación es requerido' },
            { field: 'candidateSate', msg: 'El campo estado candidato es requerido' },
            { field: 'bottomHoleCondition', msg: 'El campo condición de fondo es requerido' },
        ];
        const errors: string[] = [];
        const d = activeDiagnostic as any;
        fields.forEach((f) => {
            if (!d?.[f.field] || String(d[f.field]).trim() === '') errors.push(f.msg);
        });
        return errors;
    };

    const onSave = () => {
        const shouldSaveLevel = activeTab === 'diagnostic' && secondaryTab === 'actualizarNivel' && mode === 'liquidLevel' && variablesToUpdate;
        if (shouldSaveLevel) {
            const toSave = { ...variablesToUpdate };
            setLoading(true);
            updateFieldVariablesValues(toSave)
                .then(() => {
                    setLoading(false);
                    Swal.fire({ title: 'Guardado!', icon: 'success' });
                    dispatch(loadLocationDetails(id!));
                    onClose();
                })
                .catch(() => {
                    setLoading(false);
                    Swal.fire({ title: 'Error!', icon: 'error' });
                });
            return;
        }

        if (activeTab === 'diagnostic' && activeDiagnostic) {
            const errors = validateDiagnostic();
            if (errors.length > 0) {
                Swal.fire({ title: 'Error!', icon: 'error', html: `<ul>${errors.map((e) => `<li>${e}</li>`).join('')}</ul>` });
                return;
            }
            setLoading(true);
            UpdateDiagnosticForActivity(activeDiagnostic)
                .then(() => {
                    setLoading(false);
                    Swal.fire({ title: 'Guardado!', icon: 'success' });
                    dispatch(loadLocationDetails(id!));
                    onClose();
                })
                .catch(() => {
                    setLoading(false);
                    Swal.fire({ title: 'Error!', icon: 'error' });
                });
        }
    };

    const handleClose = () => {
        if (!loading) onClose();
    };

    const mainTabs: { value: MainTab; label: string }[] = [
        { value: 'variables', label: 'Variables' },
        { value: 'diagnostic', label: 'Diagnóstico' },
        { value: 'optimizationOptions', label: 'Opciones Optimización' },
        { value: 'requirements', label: 'Requerimientos' },
        { value: 'trabajosSubsuelo', label: 'Trabajos de Subsuelo' },
        { value: 'muestrasAyS', label: 'Muestras de AyS' },
        { value: 'steamInjection', label: 'Ciclos de Vapor' },
        { value: 'productionTest', label: 'Producción' },
    ];

    const scrollTabs = (direction: 'left' | 'right') => {
        const el = tabsScrollRef.current;
        if (el) {
            const scrollAmount = 200;
            el.scrollBy({ left: direction === 'left' ? -scrollAmount : scrollAmount, behavior: 'smooth' });
        }
    };

    const sortDynsForVariables: DynSort | null = (() => {
        if (mode === 'dynCard' && sourceData) {
            return { ...sourceData, fieldActivityId: sourceData.fieldActivityId, variables: sourceData.variables || sourceData.activityVariables || [] };
        }
        if (mode === 'liquidLevel' && liquidLevel) {
            const fieldActivity = fieldActivities?.find((fa: any) => fa.fieldActivityId === liquidLevel.fieldActivityId);
            const activity = fieldActivity || liquidLevel;
            const activityVars = activity?.activityVariables || activity?.variables || [];
            const variables = activityVars.map((v: any) => ({ variable: v.variable, value: v.value, variableIdToEdit: v.id, id: v.id }));
            if (variables.length > 0 || activity) {
                return {
                    fieldActivityId: liquidLevel.fieldActivityId,
                    executedDate: activity?.executedDate || liquidLevel?.executedDate,
                    variables,
                    dyns: [],
                    executedBy: activity?.executedBy,
                } as unknown as DynSort;
            }
        }
        return null;
    })();

    return (
        <>
        <Modal open={open} onClose={handleClose}>
            <Box className="modal_update_card_location diagnostico_v2_modal">
                <Box className="modal_header">
                    <Grid container spacing={0} sx={{ alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                        <Grid>
                            <IconButton size="small" onClick={handleClose}>
                                <CloseIcon color="error" />
                            </IconButton>
                        </Grid>
                        <Grid>
                            <Typography className="title" variant="h6" component="h2">
                                Analizar Nivel
                            </Typography>
                        </Grid>
                        <Grid>
                            {activeTab === 'diagnostic' && (
                                <IconButton size="small" onClick={onSave}>
                                    <SaveOutlinedIcon color="primary" />
                                </IconButton>
                            )}
                        </Grid>
                    </Grid>
                </Box>

                <Grid size={12} className="header_tabs">
                    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', mb: 1, px: 2, gap: 0 }}>
                        <IconButton size="small" onClick={() => scrollTabs('left')} sx={{ flexShrink: 0 }} aria-label="Scroll tabs izquierda">
                            <ChevronLeftIcon fontSize="small" />
                        </IconButton>
                        <Box
                            ref={tabsScrollRef}
                            sx={{
                                overflowX: 'auto',
                                overflowY: 'hidden',
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none',
                                display: 'flex',
                                flex: 1,
                                justifyContent: 'flex-start',
                                '&::-webkit-scrollbar': { display: 'none' },
                            }}
                        >
                            <ToggleButtonGroup
                                value={activeTab}
                                exclusive
                                onChange={(_, v) => v && setActiveTab(v)}
                                aria-label="Secciones"
                                sx={{
                                    display: 'flex',
                                    flexWrap: 'nowrap',
                                    backgroundColor: '#fff',
                                    px: 1,
                                    py: 0.5,
                                    borderRadius: 1,
                                }}
                            >
                                {mainTabs.map((tab, i, arr) => (
                                    <Box key={tab.value} sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
                                        <ToggleButton
                                            value={tab.value}
                                            sx={{
                                                border: 'none',
                                                fontSize: '14px',
                                                color: activeTab === tab.value ? 'primary.main' : 'text.secondary',
                                                fontWeight: activeTab === tab.value ? 600 : 400,
                                                px: 1.5,
                                                py: 1,
                                                textTransform: 'none',
                                                whiteSpace: 'nowrap',
                                                borderRadius: 0,
                                                borderBottom: activeTab === tab.value ? '2px solid' : 'none',
                                                borderColor: 'primary.main',
                                                '&.Mui-selected': {
                                                    backgroundColor: 'transparent',
                                                    color: 'primary.main',
                                                },
                                                '&:hover': {
                                                    backgroundColor: 'action.hover',
                                                },
                                            }}
                                        >
                                            {tab.label}
                                        </ToggleButton>
                                        {i < arr.length - 1 && <Box component="span" sx={{ mx: 0.5, color: '#888', flexShrink: 0 }}>|</Box>}
                                    </Box>
                                ))}
                                <ToggleButton
                                    value="filesManager"
                                    sx={{
                                        border: 'none',
                                        borderRadius: 0,
                                        borderBottom: activeTab === 'filesManager' ? '2px solid' : 'none',
                                        borderColor: 'primary.main',
                                        px: 1,
                                        color: activeTab === 'filesManager' ? 'primary.main' : 'text.secondary',
                                        '&.Mui-selected': {
                                            backgroundColor: 'transparent',
                                            color: 'primary.main',
                                        },
                                    }}
                                >
                                    <AttachFileIcon fontSize="small" />
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </Box>
                        <IconButton size="small" onClick={() => scrollTabs('right')} sx={{ flexShrink: 0 }} aria-label="Scroll tabs derecha">
                            <ChevronRightIcon fontSize="small" />
                        </IconButton>
                    </Box>
                </Grid>

                {loading && (
                    <>
                        <Box className="modal_analyst_loading_background" />
                        <Box className="modal__analyst_task_loading">
                            <LinearProgress /> Saving....
                        </Box>
                    </>
                )}

                <Box className="diagnostico_v2_content">
                <Grid container spacing={1} sx={{ padding: '0px 30px', pb: 2, flex: 1, minHeight: 0, overflow: 'hidden', minWidth: 0 }}>
                    {activeTab === 'variables' && (
                        <Grid size={12}>
                            {sortDynsForVariables ? (
                                <Box className="table-container">
                                    <ModalVariables sortDyns={sortDynsForVariables} open={undefined} onClose={undefined} showAsModal={false} />
                                </Box>
                            ) : (
                                <Box sx={{ p: 2 }}>
                                    <Typography variant="body2" color="text.secondary">
                                        No hay variables de actividad disponibles. Las variables de nivel (Nivel, PIP, PWF, Sumergencia) se editan en Diagnóstico → Actualizar Nivel.
                                    </Typography>
                                </Box>
                            )}
                        </Grid>
                    )}

                    {activeTab === 'diagnostic' && (
                        <Grid size={12} sx={{ display: 'flex', flexDirection: 'column', minHeight: 0, minWidth: 0, height: '100%' }}>
                            <DiagnosticoSplitView
                                activeDiagnostic={activeDiagnostic}
                                onDiagnosticChange={handleOnChangeValue}
                                condicionFondoList={condicionFondoList}
                                lastProductionTest={lastProductionTest}
                                lastWaterTest={lastWaterTest}
                                averageWaterTestsLast5={averageWaterTestsLast5}
                                mode={mode}
                                liquidLevel={liquidLevel}
                                variablesToUpdate={variablesToUpdate}
                                onChangeLiquidLevel={onChangeLiquidLevel}
                                secondaryTab={secondaryTab}
                                onSecondaryTabChange={setSecondaryTab}
                                originFieldActivityId={originFieldActivityId}
                                addRemoveOptimizationActivity={addRemoveOptimizationActivity}
                                handleConvertToMain={handleConvertToMain}
                                onOpenQuickAddRequirement={() => setShowQuickAddRequirement(true)}
                                onOpenQuickAddOptimization={() => setShowQuickAddOptimization(true)}
                                onGenerateDiagnostic={generateSimpleDiagnostic}
                            />
                        </Grid>
                    )}

                    {activeTab === 'optimizationOptions' && originFieldActivityId && (
                        <Grid size={12}>
                            <OptimizationActivities
                                originFieldActivityIdFromDiagnostic={originFieldActivityId}
                                addRemoveOptimizationActivity={() => {}}
                                handleConvertToMain={() => {}}
                                activeDiagnostic={activeDiagnostic}
                            />
                        </Grid>
                    )}

                    {activeTab === 'requirements' && originFieldActivityId && (
                        <Grid size={12} sx={{ paddingInline: 2 }}>
                            <Requerimientos
                                originFieldActivityIdFromDiagnostic={originFieldActivityId}
                                addRemoveOptimizationActivity={() => {}}
                                handleConvertToMain={() => {}}
                                activeDiagnostic={activeDiagnostic}
                            />
                        </Grid>
                    )}

                    {activeTab === 'trabajosSubsuelo' && (
                        <Grid size={12} sx={{ paddingInline: 2, p: 2 }}>
                            <SubSurfaceJobs dataToTable={subSurfaceDataTable} setdataToTable={setSubSurfaceDataTable} filteredData={[]} filters={[]} />
                        </Grid>
                    )}

                    {activeTab === 'muestrasAyS' && (
                        <Grid size={12} sx={{ paddingInline: 2 }}>
                            <WaterTest filteredData={[]} filters={[]} />
                        </Grid>
                    )}

                    {activeTab === 'steamInjection' && (
                        <Grid size={12} sx={{ paddingInline: 2, p: 2 }}>
                            <SteamModule />
                        </Grid>
                    )}

                    {activeTab === 'productionTest' && (
                        <Grid size={12} sx={{ paddingInline: 2, p: 2 }}>
                            <ProductionModule />
                        </Grid>
                    )}

                    {activeTab === 'filesManager' && originFieldActivityId && (
                        <Grid size={12} sx={{ paddingInline: 2 }}>
                            <FileAttachment originActivityId={originFieldActivityId} addRemoveAttachment={() => {}} activeDiagnostic={activeDiagnostic} />
                        </Grid>
                    )}
                </Grid>
                </Box>
            </Box>
        </Modal>
            <QuickAddOptimizationModal
                open={showQuickAddOptimization}
                onClose={() => setShowQuickAddOptimization(false)}
                originFieldActivityId={originFieldActivityId || ''}
                activeDiagnostic={activeDiagnostic}
                addRemoveOptimizationActivity={addRemoveOptimizationActivity}
                onActivityCreated={handleActivityCreated}
            />
            <QuickAddRequirementModal
                open={showQuickAddRequirement}
                onClose={() => setShowQuickAddRequirement(false)}
                originFieldActivityId={originFieldActivityId || ''}
                activeDiagnostic={activeDiagnostic}
                addRemoveOptimizationActivity={addRemoveOptimizationActivity}
                onRequirementCreated={handleRequirementCreated}
            />
        </>
    );
};
